import styled from 'styled-components';

const DROPDOWN_WIDTH = '250px';
const DROPDOWN_GAP = '32px';
const CONTENT_GAP = '24px';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${CONTENT_GAP};
`;

export const DropdownsContainer = styled.div`
  display: flex;
  gap: ${DROPDOWN_GAP};
`;

export const DropdownContainer = styled.div`
  width: ${DROPDOWN_WIDTH};
`;
